<template>
  <div class="c-loading">
    <div class="one"></div>
    <div class="two"></div>
    <div class="three"></div>
    <div class="four"></div>
  </div>
</template>

<script lang="ts">
export default {
  name: "AppLoading" 
};
</script>
